
import React, { useState, useRef, useEffect } from 'react';
import ModalWrapper from './ModalWrapper';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimePicker from 'react-time-picker';
import { BaseUrl } from '../../../Actions/Base';
import ReactSelect from "react-select"; // renamed to avoid conflict
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from "moment";
import LearnerPreSchedule from "../Assets/LearnerPreSchedule.png";
import Draggable from 'react-draggable';

const AddClassCustomScheduleLibraryPopup = ({
    setCombinedEvents,
    instituteClasses,
    studentScheduleEvents,
    setAddClassEvents,
    addClassEvents,
    CoursePackage,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    setError,
    setSelectedWeeklyScheduleDate,
    selectedWeeklyScheduleDate,
    setShowCustomTimeTableLibraryAddPopup,
    CourseInstructors,
    setFinalDrivingClassesSchedule,
    setFinalInClassClassesSchedule, setFinalOnlineClassesSchedule, finalDrivingClassesSchedule,
    finalInClassClassesSchedule, finalOnlineClassesSchedule,
    StudentAllCoursesSchedule,
    allInstructorsScheduledClasses,
    finalClassesSchedule,
    pendingNewEvent,
    getUncoveredTimeRanges,
    timeSlots,
    setFinalClassesSchedule,
    handleSelect,
    setShowStudentFreeHoursPopup,
    setShowInstituteTrainingFreeHoursPopup,
    setTrimmedInfo,
    showStudentFreeHoursPopup,
    showInstituteTrainingFreeHoursPopup,
    showLearnerPreSchedulePopup
}) => {
  const [classSelectedType, setClassSelectedType] = useState(""); // Driving, Online, InClass
  const [selectedDropdownInstructorId, setSelectedDropdownInstructorId] = useState("");
  
useEffect(() => {
  if (!pendingNewEvent) return;

  console.log("pendingNewEvents are:", pendingNewEvent);

  // Safely extract and parse dates
  const rawStart = pendingNewEvent?.StartTime || pendingNewEvent?.startDate;
  const rawEnd = pendingNewEvent?.EndTime || pendingNewEvent?.endDate;

  const start = moment(rawStart);
  const end = moment(rawEnd);

  // Check for valid Moment dates
  if (!start.isValid() || !end.isValid()) {
    console.warn("Invalid StartTime or EndTime in pendingNewEvent:", { rawStart, rawEnd });
    return;
  }

  // Set state safely
  setSelectedWeeklyScheduleDate(start); // Moment object
  setStartTime(start.format("H:mm"));   // e.g., "14:00"
  setEndTime(end.format("H:mm"));       // e.g., "15:30"
}, [pendingNewEvent]);

  
  // Function to handle date selection by the user
  const handleDateChange = (newValue) => {
    setSelectedWeeklyScheduleDate(newValue);
  }; 

  const handleCancelPopupClick = () =>{
    setError("");
    setShowStudentFreeHoursPopup(false);
    setShowInstituteTrainingFreeHoursPopup(false);
    setShowCustomTimeTableLibraryAddPopup(false)
  }
  
  const handleLibraryAddClassFunction = () => {
    // 1. Validation
    if (!classSelectedType || !selectedDropdownInstructorId) {
      setError("Please select both class type and instructor.");
      setTimeout(() => setError(''), 10000);
      return;
    }

    // ✅ Check if any class of this type already exists (in final or addClass arrays)
    const hasTypeInFinal =
    (classSelectedType === "Driving" && finalDrivingClassesSchedule.length > 0) ||
    (classSelectedType === "Online" && finalOnlineClassesSchedule.length > 0) ||
    (classSelectedType === "InClass" && finalInClassClassesSchedule.length > 0);
    console.log("hasTypeInFinal", hasTypeInFinal);

    const hasTypeInAddEvents = addClassEvents.some(event => event.ClassType === classSelectedType);
    console.log("hasTypeInAddEvents", hasTypeInAddEvents);

    if (!hasTypeInFinal && !hasTypeInAddEvents) {
    setError(`You cannot create a ${classSelectedType} class unless at least one already exists.`);
    setTimeout(() => setError(''), 10000);
    return;
    }

    
    if (!selectedWeeklyScheduleDate || !startTime || !endTime) {
      console.log("Validation failed", { selectedWeeklyScheduleDate, startTime, endTime });
      setError('Please select a date and both start/end time.');
      setTimeout(() => setError(''), 10000); // auto-clear after 5 seconds
      return;
    }

    const start = new Date(`1970-01-01T${startTime}`);
    const end = new Date(`1970-01-01T${endTime}`);
    const durationInHours = (end - start) / (1000 * 60 * 60);
  
    if (durationInHours > 8) {
      setError('The class duration exceeds 8 hours. Please reduce the time.');
      setTimeout(() => setError(''), 10000);
      return;
    }
  
    if (durationInHours <= 0) {
      setError('End time must be after start time.');
      setTimeout(() => setError(''), 10000);
      return;
    }
  
    setError('');

    // ✅ Check if selected date is in the future
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Ignore time, just compare date

    const selectedDate = new Date(selectedWeeklyScheduleDate);
    selectedDate.setHours(0, 0, 0, 0);

    if (selectedDate <= today) {
    setError('Please select a date in the future to schedule the class.');
    setTimeout(() => setError(''), 10000);
    return;
    }
  
    const classType = classSelectedType;
    const totalHoursForType = CoursePackage?.[`${classType}Hours`] || 0;
  
    const getTotalScheduledHours = (scheduleArray) => {
      return scheduleArray.reduce((total, cls) => {
        const start = new Date(cls.StartTime);
        const end = new Date(cls.EndTime);
        return total + (end - start) / (1000 * 60 * 60); // in hours
      }, 0);
    };
  
    let existingScheduledHours = 0;
    if (classType === "Driving") {
      existingScheduledHours = getTotalScheduledHours(finalDrivingClassesSchedule);
    } else if (classType === "Online") {
      existingScheduledHours = getTotalScheduledHours(finalOnlineClassesSchedule);
    } else if (classType === "InClass") {
      existingScheduledHours = getTotalScheduledHours(finalInClassClassesSchedule);
    }
  
    const remainingAllowedHours = totalHoursForType - existingScheduledHours;
    if (remainingAllowedHours <= 0) {
      setError(`Cannot schedule more classes. Total allowed hours (${totalHoursForType}) already used.`);
      return;
    }
  
    const typeToIndex = {
      Driving: 0,
      Online: 1,
      InClass: 2,
    };
  
    const idx = typeToIndex[classSelectedType] ?? 0;
    const instructorId = selectedDropdownInstructorId; // new

    const matchedInstructor = CourseInstructors.find(
      instructor => instructor?.Instructor?.InstructorId === instructorId
    );
    console.log("matchedInstructor in function is:",matchedInstructor)

    const instructorFullName = matchedInstructor
      ? `${matchedInstructor.FirstName} ${matchedInstructor.LastName}`
      : "";
    console.log("instructorFullName in function is:",instructorFullName)
    const typeColors = {
      Driving: '#0AA630',
      Online: '#FC0000',
      InClass: '#1F7BF4',
    };
  
    // 2. Setup baseDate and time parsing
    const baseDate = new Date(new Date(selectedWeeklyScheduleDate).setHours(0, 0, 0, 0));
    const [startHour, startMin] = startTime.split(':');
    const [endHour, endMin] = endTime.split(':');
  
    const startDate = new Date(baseDate);
    startDate.setHours(+startHour, +startMin, 0, 0);
  
    const endDate = new Date(baseDate);
    endDate.setHours(+endHour, +endMin, 0, 0);

     // ✅ Validate against institute training hours
     if (classType !== "Online") {

        const classDay = startDate.toLocaleDateString('en-US', { weekday: 'long' });
        const daySlots = timeSlots.filter(slot => slot.DayOfWeek === classDay);
        const uncovered = getUncoveredTimeRanges(startTime, endTime, daySlots);

        if (uncovered.length > 0) {
        const messages = uncovered.map(({ start, end }) => {
            const timeRange = `${start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
            return `Class on ${classDay} during ${timeRange} is outside the institute training hours.`;
        });

        setError(messages.join('\n'));
        setTimeout(() => setError(''), 10000);
        return;
        }
    }
  
    const proposedDurationInHours = (endDate - startDate) / (1000 * 60 * 60);
  
    if (proposedDurationInHours > remainingAllowedHours) {
      const trimmedEndDate = new Date(startDate.getTime() + remainingAllowedHours * 60 * 60 * 1000);
      endDate.setTime(trimmedEndDate.getTime());
      const formattedTrimmedTime = `${startDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${trimmedEndDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

      setTrimmedInfo(`The selected time exceeds the remaining allowed hours (${remainingAllowedHours}).The class will be automatically trimmed to ${formattedTrimmedTime} hour(s).`);
      setTimeout(() => setTrimmedInfo(''), 10000);
      console.log(`Class trimmed to fit remaining ${remainingAllowedHours} hour(s).`);
    }
  
    // 🔍 3. Conflict Check
    const studentScheduleTimes = StudentAllCoursesSchedule.map(item => ({
        start: new Date(item.startDate || item.StartTime),
        end: new Date(item.endDate || item.EndTime),
    }));

    const instructorScheduleTimes = allInstructorsScheduledClasses
        .filter(item => item.InstructorId === instructorId || item.InstructorFK === instructorId)
        .map(item => ({
        start: new Date(item.startDate || item.StartTime),
        end: new Date(item.endDate || item.EndTime),
        }));

    const overlaps = (aStart, aEnd, bStart, bEnd) =>
        aStart < bEnd && bStart < aEnd;

    const formattedDate = startDate.toLocaleDateString('en-US');
    const formattedTime = `${startDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${endDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

    const studentConflict = studentScheduleTimes.find(existing =>
        overlaps(startDate, endDate, existing.start, existing.end)
    );
    if (studentConflict) {
        const overlapStart = new Date(Math.max(startDate.getTime(), studentConflict.start.getTime()));
        const overlapEnd = new Date(Math.min(endDate.getTime(), studentConflict.end.getTime()));

        const conflictDate = overlapStart.toLocaleDateString('en-US');
        const conflictTime = `${overlapStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${overlapEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

        setError(`Student already has a class on ${conflictDate} at ${conflictTime} for another course.`);
        setTimeout(() => setError(''), 10000);
        return;
    }

    const instructorConflict = instructorScheduleTimes.find(existing =>
        overlaps(startDate, endDate, existing.start, existing.end)
    );
    if (instructorConflict) {
        const overlapStart = new Date(Math.max(startDate.getTime(), instructorConflict.start.getTime()));
        const overlapEnd = new Date(Math.min(endDate.getTime(), instructorConflict.end.getTime()));

        const conflictDate = overlapStart.toLocaleDateString('en-US');
        const conflictTime = `${overlapStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${overlapEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

        setError(`Instructor already has a class on ${conflictDate} at ${conflictTime} for another course.`);
        setTimeout(() => setError(''), 10000);
        return;
    }

    // ❌ Conflict with other classes of this course (Driving, InClass, Online - all types)
    const courseSchedule = [
        ...addClassEvents,
        ...finalDrivingClassesSchedule,
        ...finalOnlineClassesSchedule,
        ...finalInClassClassesSchedule,
    ];
    
    const courseConflict = courseSchedule.find(existing => {
        const existingStart = new Date(existing.startDate || existing.StartTime);
        const existingEnd = new Date(existing.endDate || existing.EndTime);
        const existingDate = existingStart.toDateString();
        const newDate = startDate.toDateString();
    
        return existingDate === newDate && overlaps(startDate, endDate, existingStart, existingEnd);
    });
    
    if (courseConflict) {
        const overlapStart = new Date(Math.max(startDate.getTime(), new Date(courseConflict.startDate || courseConflict.StartTime).getTime()));
        const overlapEnd = new Date(Math.min(endDate.getTime(), new Date(courseConflict.endDate || courseConflict.EndTime).getTime()));
    
        const conflictDate = overlapStart.toLocaleDateString('en-US');
        const conflictTime = `${overlapStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${overlapEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    
        setError(`A class for this course already exists on ${conflictDate} at ${conflictTime}.`);
        setTimeout(() => setError(''), 10000);
        return;
    }

    // 3. New Class Object
    const newClass = {
      allDay: false,
      Subject: classSelectedType === 'Driving' ? 'In-Vehicle Class' : `${classSelectedType} Class`,
      // Subject: `${classSelectedType} Class`,
      StartTime: startDate,
      EndTime: endDate,
      startDate: startDate,
      endDate: endDate,
      start: startDate.toISOString(),
      end: endDate.toISOString(),
      text: '',
      ClassType: classSelectedType,
      Instructors: instructorId,
      event_id: `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
      ClassNo: addClassEvents.length + 1,
      CategoryColor: typeColors[classSelectedType] || '#000000',
      sourceType: 'addClass',
      InstructorName: instructorFullName,
    };
  
    const updatedAddClassEvents = [...addClassEvents, newClass];
    // setAddClassEvents(updatedAddClassEvents);
    setFinalClassesSchedule(prev => [...prev, newClass]);
  
    if (classSelectedType === "Driving") {
      setFinalDrivingClassesSchedule(prev => [...prev, newClass]);
    } else if (classSelectedType === "Online") {
      setFinalOnlineClassesSchedule(prev => [...prev, newClass]);
    } else if (classSelectedType === "InClass") {
      setFinalInClassClassesSchedule(prev => [...prev, newClass]);
    }
  
    setCombinedEvents([
      ...studentScheduleEvents,
      ...instituteClasses,
      ...updatedAddClassEvents,
      ...finalClassesSchedule,
    ]);
  
    // 4. Reset and close modal
    setSelectedWeeklyScheduleDate(null);
    setShowCustomTimeTableLibraryAddPopup(false);
    setError("");
  };
  
  const isAnyPopupOpen = showStudentFreeHoursPopup || showInstituteTrainingFreeHoursPopup || showLearnerPreSchedulePopup;

  return (
    <Draggable disabled={showStudentFreeHoursPopup || showInstituteTrainingFreeHoursPopup || showLearnerPreSchedulePopup}>
        <div className="relative rounded-[9px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] pl-[30px] pr-[30px] pb-[10px] pt-[5px] shadow-lg w-[420px]"
        style={{
            cursor: 'move', 
            // ...(isAnyPopupOpen && {
            //   position: 'relative',
            //   left: '50%',
            //   top: '10%',
            //   transform: 'translate(-50%, -50%)',
            // }),
          }}> 
            <div className="absolute top-2 right-2">
              <img
                className="absolute right-1 top-[4px] pointer-events-auto z-50"
                src={require("../Assets/Cross.svg").default}
                alt=""
                onClick={handleCancelPopupClick}
              />
            </div>

            {/* {(classSelectedType !== "Online") && (
              <div className='w-full flex flex-col gap-[5px] items-end absolute top-[45px] right-2'>
                  <img src={require("../Assets/LearnerHours.svg").default} alt="" className="cursor-pointer" title="Learner Free Hours" // Tooltip here 
                    onClick={() => handleSelect('freeHours')}/>
                  <img src={require("../Assets/TrainingHours.svg").default} alt="" className="cursor-pointer" title="Institute Training Hours" // Tooltip here
                    onClick={() => handleSelect('weeklySchedule')} />
                  {StudentAllCoursesSchedule?.length > 0 && (
                  <img src={LearnerPreSchedule} alt="" className="cursor-pointer" title="Learner Pre-Scheduled Classes" // Tooltip here
                  onClick={() => handleSelect('LearnerPreSchedule')} />
                    )}
              </div>
            )} */}

            {(classSelectedType !== "Online") && (
            <div className='w-full flex-col gap-[15px] absolute top-[5px] left-3'>
              <div className='w-full flex gap-[10px] '>
                  <img src={require("../Assets/LearnerHours.svg").default} alt="" className="cursor-pointer" title="Learner Free Hours" // Tooltip here 
                    onClick={() => handleSelect('freeHours')}/>
                   <img src={LearnerPreSchedule} alt="" className="cursor-pointer" title="Learner Pre-Scheduled Classes" // Tooltip here
                    onClick={() => handleSelect('LearnerPreSchedule')} />
              </div>
              <div>
                {StudentAllCoursesSchedule?.length > 0 && (
                  <img src={require("../Assets/TrainingHours.svg").default} alt="" className="cursor-pointer" title="Institute Training Hours" // Tooltip here
                  onClick={() => handleSelect('weeklySchedule')} />
                  )}
              </div>
            </div>
            )
            }
          
          <div className='w-full flex flex-col justify-center gap-[5px] items-center mt-[15px]'>
              {/* <img src={require("../Assets/AddClassPopupPics.svg").default} alt="" /> */}
              <p className='text-[16px] font-semibold'>
                  Set up class Schedule 
              </p>
              <p className='text-[16px]'>Set up a new class for the learner.</p>
          </div>

          {/* Class Type Dropdown */}
          <div className='relative flex flex-col gap-[5px] mt-[15px]'>
            <label className='text-[16px] text-[#333333] font-semibold'>Class Type</label>
            <select
              className='w-full p-[8px] bg-transparent text-[#333] appearance-none border border-[#AEB0FF] rounded'
              style={{
                backgroundColor: 'transparent',   // <-- inline style ensures transparency
                WebkitAppearance: 'none',         // <-- for Safari
                MozAppearance: 'none',            // <-- for Firefox
                appearance: 'none',
              }}
              value={classSelectedType}
              onChange={(e) => setClassSelectedType(e.target.value)}
            >
              <option value="" disabled>Select Class Type</option>
              <option value="Driving">In-Vehicle</option>
              <option value="InClass">In-Class</option>
              <option value="Online">Online</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-[5px] top-[25px] flex items-center text-[#AEB0FF]">
              ▼
            </div>
          </div>

          {/* Instructor Dropdown */}
          <div className='relative  flex flex-col gap-[5px] mt-[5px]'>
            <label className='text-[16px] text-[#333333] font-semibold'>Instructor</label>
            <select
              className='w-full p-[8px] bg-transparent text-[#333] appearance-none border border-[#AEB0FF] rounded'
              style={{
                backgroundColor: 'transparent',   // <-- inline style ensures transparency
                WebkitAppearance: 'none',         // <-- for Safari
                MozAppearance: 'none',            // <-- for Firefox
                appearance: 'none',
              }}
              value={selectedDropdownInstructorId}
              onChange={(e) => setSelectedDropdownInstructorId(e.target.value)}
            >
              <option value="" disabled>Select Instructor</option>
              {CourseInstructors.map((ins) => (
                <option key={ins?.Instructor?.InstructorId} value={ins?.Instructor?.InstructorId}>
                  {ins.FirstName} {ins.LastName}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-[5px] top-[25px] flex items-center text-[#AEB0FF]">
              ▼
            </div>
          </div>

          <div className='flex flex-col pt-[10px] gap-[10px]'>
            <div className='flex items-center gap-[35px]'>
                <p className='text-[16px] text-[#333333] font-semibold'>Date</p>
                <div className='w-full'>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                          value={selectedWeeklyScheduleDate}
                          onChange={handleDateChange}
                          PopperProps={{
                            sx: {
                              zIndex: 99999, // Increase this value as needed
                            },
                          }}
                          renderInput={(params) => 
                            <TextField
                              {...params}
                              variant="outlined"
                              sx={{
                                '& .MuiInputBase-root': {
                                  height: '22px', // Total height of the field
                                  minHeight: '22px',
                                  padding: '0',
                                  fontSize: '10px',
                                },
                                '& .MuiInputBase-input': {
                                  padding: '2px 6px',
                                  height: '100%',
                                  fontSize: '10px',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#AEB0FF',
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#AEB0FF',
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#AEB0FF',
                                },
                              }}
                            />}
                      />
                  </LocalizationProvider>
                </div>
            </div>

            <div className=' flex items-center gap-[10px]'>
              <p className='text-[16px] text-[#333333] font-semibold'>From</p>
                {/* <TimePicker
                  onChange={setStartTime}
                  value={startTime}
                  disableClock
                  clearIcon={null}
                  format="h:mm a"
                  className="custom-time-picker"
                /> */}
                <TimePicker
                  onChange={(value) => {
                    if (value) {
                      const [hours, minutesRaw] = value.split(':');
                      const minutes = parseInt(minutesRaw, 10);

                      // Only accept 0 or 30 minutes
                      if (minutes !== 0 && minutes !== 30) {
                        setError("Only 0 or 30 minutes allowed");
                        setStartTime(null); // or keep the previous
                        return;
                      }

                      setError('');
                      setStartTime(value);
                    } else {
                      setStartTime(null);
                    }
                  }}
                  value={startTime}
                  disableClock
                  clearIcon={null}
                  format="h:mm a"
                  className="custom-time-picker"
                />
            </div>

            <div className='flex items-center gap-[30px]'>
              <p className='text-[16px] text-[#333333] font-semibold'>To</p>
                {/* <TimePicker
                  onChange={setEndTime}
                  value={endTime}
                  disableClock
                  clearIcon={null}
                  format="h:mm a"
                  className="custom-time-picker"
                /> */}
                <TimePicker
                  onChange={(value) => {
                    if (value) {
                      const [hours, minutesRaw] = value.split(':');
                      const minutes = parseInt(minutesRaw, 10);

                      if (minutes !== 0 && minutes !== 30) {
                        setError("Only 0 or 30 minutes allowed");
                        setEndTime(null);
                        return;
                      }

                      setError('');
                      setEndTime(value);
                    } else {
                      setEndTime(null);
                    }
                  }}
                  value={endTime}
                  disableClock
                  clearIcon={null}
                  format="h:mm a"
                  className="custom-time-picker"
                />
            </div>

            {/* {error && <p className="text-[#FF0000]">{error}</p>} */}

            <div className='mt-[10px] w-full flex flex-col justify-center items-center gap-[10px]'>
                <button
                  type="button"
                  className="rounded-[5px] bg-[#B5AAFF] w-[302px] h-[42px] text-[14px] text-white"
                  onClick={handleLibraryAddClassFunction}
                >
                  Add Class
                </button>
              
                <button
                  type="button"
                  className=" text-[#B5AAFF] text-[14px]"
                  onClick={handleCancelPopupClick}
                >
                  Cancel
                </button>
            </div>
          </div>
        </div>
    </Draggable>
  );
};

export default AddClassCustomScheduleLibraryPopup;
